var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-route"},_vm._l((['mainBlue', 'mainYellow', 'mainGreen', 'mainRed']),function(item,index){return _c('div',{key:item,class:("loading-route__circle item-" + index + " " + item)})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }